import { createContext } from "react";

const AccessTokenContext = createContext();

export default AccessTokenContext;
